<template>
  <div class="provincias-search-list">
    <b-row>
      <b-col cols="12" xl="12">
        <b-form>
          <b-form-group
            label="Nombre:"
            label-for="nombre"
            :label-cols="2"
            horizontal>
            <b-form-input 
              id="nombre" 
              v-model= "nombre" 
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-table hover  
            responsive="sm" 
            class="registro"
            :busy="tableBusy"
            :items="provincias" 
            :fields="provinciasFields"
            :filter="nombre"
            :filter-function="filter"
            :current-page="paginaActual"
            :per-page="registrosPorPagina"
            @filtered="onFiltered"
            @row-clicked="seleccionarProvincia">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" 
            prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'Provincias',
  data: () => {
    return {
      provincias: [],
      provinciasFields: [
        // {
        //   key: 'id',
        //   label: 'Cód.'
        // },
        {
          key: 'nombre',
          label: 'Cliente',
          sortable: true
        },
      ],

      loaded: false,
      tableBusy: false,

      /* Info de paginación */
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 5,
      totalRegistros: 0,

      nombre: null,
    }
  },
  computed: {
  },
  created() {
    this.getProvincias();
  },  
  methods: {
    getProvincias() {
      this.tableBusy = true;
      this.$store.dispatch('provincias/getList')
        .then(() => {
          this.provincias = this.$store.getters['provincias/list'];
          this.totalRegistros = this.provincias.length;
          this.tableBusy = false;
        })
    },
    seleccionarProvincia (item) {
      this.$emit('provinciaSeleccionada', item)
    },
    filter(row, nombre) {
      return row.nombre.toUpperCase().trim().includes(nombre.toUpperCase().trim());
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    }    
  },
}
</script>

<style>
  /* .provincias-search-list table td[aria-colindex="1"] {
    width: 20%;
  }
  .provincias-search-list table td[aria-colindex="2"] {
    width: 80%;
  } */
</style>
